(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-card"] && !Shopify.designMode) return;
  try {
    (function () {
  /**
   * PCM — AJAX Add to Cart
   *
   * Uses the Horizon-native 'cart:update' CustomEvent so the cart drawer
   * and cart icon bubble update automatically — no direct DOM hacking needed.
   *
   * Confirmed working on Horizon 3.0+ (community.shopify.dev, Nov 2025)
   */

  function setState(btn, state) {
    if (state) {
      btn.setAttribute('data-state', state);
      btn.disabled = true;
    } else {
      btn.removeAttribute('data-state');
      btn.disabled = false;
    }
  }

  function triggerHorizonCartUpdate() {
    fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        // This is the exact event Horizon 3.x listens for.
        // 'source: product-form-component' makes it behave like a native ATC.
        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              data: {
                itemCount: cart.item_count,
                source: 'product-form-component'
              }
            }
          })
        );
      });
  }

  function handleAtcSubmit(e) {
    e.preventDefault();

    var form = e.currentTarget;
    var btn  = form.querySelector('.pcm-btn--atc');
    if (!btn) return;

    setState(btn, 'loading');

    var body = new FormData(form);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: body
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart_add_failed');
        return res.json();
      })
      .then(function () {
        setState(btn, 'added');
        triggerHorizonCartUpdate();
        setTimeout(function () { setState(btn, null); }, 2000);
      })
      .catch(function () {
        setState(btn, 'error');

        var label = btn.querySelector('.pcm-btn-label');
        var orig  = label ? label.textContent : '';
        if (label) label.textContent = 'Try again';

        setTimeout(function () {
          setState(btn, null);
          if (label) label.textContent = orig;
        }, 2000);
      });
  }

  function init() {
    document.querySelectorAll('form[data-atc-form]').forEach(function (form) {
      if (form._pcmAtcBound) return;
      form._pcmAtcBound = true;
      form.addEventListener('submit', handleAtcSubmit);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select',  init);
})();
  } catch(e) { console.error(e); }
})();

})();
